import { Injectable } from '@angular/core';

@Injectable()
export class DeviceService {

    constructor() { }

    public IsMobile(): boolean {
        return !(window.innerWidth >= 768);
    }

    public IsTablet(): boolean {
        return (window.innerWidth >= 768 && window.innerWidth <= 1200);
    }

    public IsDesktop(): boolean {
        return (window.innerWidth > 1200);
    }

    public isAndroidPhone(): boolean {
        const ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/device.service.ts